import useExportOffers from "../../data/useExportOffers";
import { ExportType } from "../../models/ExportOffer";
import { IVehicle } from "../../models/Vehicle";
import classNames from "../../utils/classNames";
import ContactFromId from "../contacts/ContactFromId";
import { ButtonInput } from "../shared/Inputs/ButtonInput";


export default function ExportOffersModal({ vehicle }: { vehicle: IVehicle }) {
  const { accept } = useExportOffers();

  const handleAccept = (offerId: any) => {
    accept.mutate(offerId);
  };

  return (
    <div>
      <div className="flex flex-col gap-2">
        <h3 className="text-lg font-semibold">Export Offers</h3>
        <div className="flex flex-col gap-2">
          {vehicle.exportOffers?.map((offer) => (
            <div key={offer.id}
              className={classNames(
                offer.isAccepted
                  ? "bg-green-300 rounded"
                  : offer.price === 0
                  ? "bg-red-100 rounded"
                  : "",
                "flex rounded bg-gray-100 items-center justify-between p-2"
              )}
            >
              <div>
                <span>{ExportType[offer.type]}</span>
                <span className="text-sm text-gray-500 ml-2">by <ContactFromId contactId={offer.userId!} /></span>
              </div>
              <div className="flex items-center gap-2">
                <span>£{offer.price}</span>

                {offer.price > 0 && (
                  <ButtonInput
                    label="Accept"
                    onClick={() => handleAccept(offer.id)}
                    disabled={offer.isAccepted}
                    classes={undefined}
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}